<template>
  <div
    class="pt-5 pb-6"
    :class="$vuetify.breakpoint.xlOnly ? 'screen-xl' : 'screen-under-xl'"
  >
    <!--     <HistoricalDataFilter
      @filterChanged="filterChanged"
      @toggleNavigation="toggleNavigation"
    /> -->

    <HistoricalDataCharts
      v-if="typeHistoricalSelected.id == 0"
      :daily="daily"
      :dailyPeriods="dailyPeriods"
      :hourlyPeriods="hourlyPeriods"
      :typeLocation="typeLocation"
      :filterSelected="filterSelected"
      @toggleNavigation="toggleNavigation"
    />

    <v-navigation-drawer
      ref="drawer"
      app
      right
      :width="navigation.width"
      v-model="navigation.show"
      temporary
    >
      <DashboardFilter
        @filterChanged="filterChanged"
        @toggleNavigation="toggleNavigation"
        @toggleTypeHistorical="toggleTypeHistorical"
      />
    </v-navigation-drawer>
    <HistoricalDataTables
      v-if="typeHistoricalSelected.id == 1"
      :daily="daily"
      :dailyPeriods="dailyPeriods"
      :hourlyPeriods="hourlyPeriods"
      :typeLocation="typeLocation"
      :filterSelected="filterSelected"
      :dailyPeriodsTable="dailyPeriodsTable"
      :dailyDataFilter="dailyDataFilter"
      :hourlyPeriodsTable="hourlyPeriodsTable"
      :hourlyDataFilter="hourlyDataFilter"
      @toggleNavigation="toggleNavigation"
    />
  </div>
</template>

<script>
import moment from "moment";
//import HistoricalDataFilter from "@/components/historical/HistoricalDataFilter.vue";
import HistoricalDataCharts from "@/components/historical/HistoricalDataCharts.vue";
import DashboardFilter from "@/components/historical/DashboardFilter.vue";

import HistoricalDataTables from "@/components/historical/HistoricalDataTables.vue";
export default {
  components: {
    // HistoricalDataFilter,
    HistoricalDataCharts,
    DashboardFilter,
    HistoricalDataTables,
  },
  data: () => ({
    date: moment().subtract(1, "days").format("YYYY-MM-DD"),
    daily: true,
    dailyPeriods: {
      dates: [],
      hours: [
        { id: 0, name: "00:00", text: "Manhã" },
        { id: 1, name: "12:00", text: "Tarde" },
      ],
    },
    hourlyPeriods: [],
    hourlyDataFilter: [],
    typeLocation: "regional",
    filterSelected: {
      date: moment().subtract(1, "days").format("YYYY-MM-DD"),
      hour: "",
      location: {
        fullname: "Oeste",
        id: 1,
        name: "OES",
      },
      periodId: 1,
      type: "regional",
    },
    navigation: {
      show: false,
      width: 1200,
      borderSize: 5,
    },
    typeHistoricalSelected: {
      id: 0,
      name: "GRÁFICOS",
      icon: "icon-alertadis-chart",
    },
    dailyPeriodsTable: {
      dates: [],
      hours: [
        { id: 0, name: "00:00", text: "Manhã" },
        { id: 1, name: "12:00", text: "Tarde" },
      ],
    },
    hourlyPeriodsTable: [],

    dailyDataFilter: [],
  }),

  created() {
    this.setDate(moment().subtract(1, "days").format("YYYY-MM-DD"));
    this.setHours(moment().subtract(1, "days").format("YYYY-MM-DD"), 0);
  },
  methods: {
    filterChangedTable(filter) {
      if (filter.periodId == 1) {
        this.fetchDailyInterruptedHistoricalTable(filter);

        return;
      }

      this.fetchHourlyInterruptedHistoricalTable(filter);
    },

    filterChanged(filter) {
      this.typeLocation = filter.type;

      if (filter.typeHistoricalSelected == 0) {
        const { date, hour } = filter;
        if (filter.periodId == 1) {
          this.setDate(date);
          this.daily = true;
          this.fetchDailyInterruptedHistorical(filter);
        } else {
          this.setHours(date, hour);
          this.daily = false;
          this.fetchHourlyInterruptedHistorical(filter);
        }

        return;
      }

      this.filterChangedTable(filter);
    },
    setDate(date) {
      this.dailyPeriods.dates = [
        {
          id: 1,
          name: moment(date).subtract(4, "days").format("ddd. DD/MM/YYYY"),
        },
        {
          id: 2,
          name: moment(date).subtract(3, "days").format("ddd. DD/MM/YYYY"),
        },
        {
          id: 3,
          name: moment(date).subtract(2, "days").format("ddd. DD/MM/YYYY"),
        },
        {
          id: 4,
          name: moment(date).subtract(1, "days").format("ddd. DD/MM/YYYY"),
        },
        {
          id: 5,
          name: moment(date).format("ddd. DD/MM/YYYY"),
        },
      ];
    },
    setHours(date, hour) {
      this.hourlyPeriods = [
        {
          id: 1,
          name: moment(date)
            .hour(hour)
            .subtract(2, "hours")
            .format("DD/MM/YYYY HH:mm"),
          date: moment(date)
            .hour(hour)
            .subtract(2, "hours")
            .format("YYYY-MM-DD"),
          hour: hour,
        },
        {
          id: 2,
          name: moment(date)
            .hour(hour)
            .subtract(1, "hours")
            .format("DD/MM/YYYY HH:mm"),
          date: moment(date)
            .hour(hour)
            .subtract(1, "hours")
            .format("YYYY-MM-DD"),
          hour: hour,
        },
        {
          id: 3,
          name: moment(date).hour(hour).format("DD/MM/YYYY HH:mm"),
          date: moment(date).hour(hour).format("YYYY-MM-DD"),
          hour: hour,
        },
      ];
    },
    fetchDailyInterruptedHistorical(filter) {
      const { type } = filter;
      this.filterSelected = filter;
      filter.runtimeHourMinute = "00:00";
      const runtimes = this.dailyPeriods.dates.map((el) => {
        let date = el.name.split(" ")[1];

        let hour = parseInt(filter.runtimeHourMinute.split(":")[0]);
        date = moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
        let runtime = moment.utc(date).hour(hour).toISOString();
        return runtime;
      });
      if (type == "countie") {
        this.$store.dispatch("fetchRecordedDataFromTelmetryStationsDailyCity", {
          cityId: filter.location.cityId,
          date: filter.date,
        });
        this.$store.dispatch("fetchDailyLightningCountCity", {
          date: filter.date,
          agencyIds: filter.location.agencies,
        });

        this.$store.dispatch("fetchDailyHistoricalCountieData", filter);
        this.$store.dispatch("fetchDailyHistoricalFullData", filter);

        this.$store.dispatch(
          "fetchHistoricalAgencyQtdeUc",
          filter.location.regionalId
        );
        filter.runtimes = runtimes;
        this.$store.dispatch("fetchDailyHistoricalForecastsCouties", filter);
      }
      if (type == "agency") {
        this.$store.dispatch("fetchDailyHistoricalAgencyData", filter);
        this.$store.dispatch("fetchDailyHistoricalFullData", filter);
        this.$store.dispatch(
          "fetchHistoricalAgencyQtdeUc",
          filter.location.regionalId
        );
        this.$store.dispatch(
          "fetchRecordedDataFromTelmetryStationsDailyAgency",
          {
            agencyId: filter.location.id,
            date: filter.date,
          }
        );

        this.$store.dispatch("fetchDailyLightningCountAgency", {
          regionalId: filter.location.regionalId,
          date: filter.date,
        });
      }
      if (type == "regional") {
        this.$store.dispatch("fetchWeatherData", {
          regionalId: filter.location.id,
          date: filter.date,
        });
        this.$store.dispatch("fetchRecordedDataFromTelmetryStationsDaily", {
          regionalId: filter.location.id,
          date: filter.date,
        });

        this.$store.dispatch("fetchDailyLightningCountRegional", {
          date: filter.date,
        });
        this.$store.dispatch("fetchDailyHistoricalRegionalData", filter);
        this.$store.dispatch("fetchHistoricalAgencyQtdeUc", filter.location.id);
        this.$store.dispatch("fetchDailyHistoricalFullRegionalData", filter);
        this.$store.dispatch("fetchHistoricalRegionalQtdeUc");

        filter.runtimes = runtimes;
        this.$store.dispatch("fetchDailyHistoricalForecastsRegionals", filter);
      }
    },
    fetchHourlyInterruptedHistorical(filter) {
      const { type } = filter;
      this.filterSelected = filter;
      filter.typeSelected = "graphic";
      const runtimes = this.hourlyPeriods.map((el) => {
        let [date, hour] = el.name.split(" ");
        date = moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
        hour = parseInt(hour.split(":")[0]);
        const toUtc = moment(date)
          .hour(hour)
          .utc()
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
        return toUtc;
      });

      // this.$store.dispatch("fetchHistoricalAgencyQtdeUc", filter);
      if (type == "countie") {
        this.$store.dispatch(
            "fetchRecordedDataFromTelmetryStationsDailyCity",
            {
              cityId: filter.location.cityId,
              date: filter.date,
            }
          );

          this.$store.dispatch("fetchDailyLightningCountCity", {
            date: filter.date,
            agencyIds: filter.location.agencies,
          });
        this.$store.dispatch("fetchHourlyHistoricalCountieData", filter);
        this.$store.dispatch("fetchHourlyHistoricalFullData", filter);
        this.$store.dispatch(
          "fetchHistoricalAgencyQtdeUc",
          filter.location.regionalId
        );
        filter.runtimes = runtimes;
        this.$store.dispatch("fetchHourlyHistoricalForecastsCouties", filter);
      }
      if (type == "regional") {
        this.$store.dispatch("fetchWeatherData", {
          regionalId: filter.location.id,
          date: filter.date,
        });
        this.$store.dispatch("fetchHourlyHistoricalRegionalData", filter);
        this.$store.dispatch("fetchHistoricalAgencyQtdeUc", filter.location.id);
        this.$store.dispatch("fetchHistoricalRegionalQtdeUc");
        this.$store.dispatch("fetchHourlyHistoricalFullRegionalData", filter);
        filter.runtimes = runtimes;
        this.$store.dispatch("fetchHourlyHistoricalForecastsRegionals", filter);
        this.$store.dispatch(
          "fetchRecordedDataFromTelmetryStationsHourlyRegional",
          filter
        );
        this.$store.dispatch("fetchHourlyLightningCountRegional", filter);
      }
      if (type == "agency") {
        this.$store.dispatch(
            "fetchRecordedDataFromTelmetryStationsHourlyAgency",
            filter
          );
          this.$store.dispatch("fetchHourlyLightningCountAgency", filter);
        this.$store.dispatch("fetchHourlyHistoricalAgencyData", filter);
        this.$store.dispatch("fetchHourlyHistoricalFullData", filter);
        this.$store.dispatch(
          "fetchHistoricalAgencyQtdeUc",
          filter.location.regionalId
        );
        filter.runtimes = runtimes;
        this.$store.dispatch("fetchHourlyHistoricalForecastsAgencies", filter);
      }
    },

    fetchDailyInterruptedHistoricalTable(filter) {
      this.daily = true;
      const { startDate, endDate } = filter;
      this.dailyPeriodsTable.dates = [];
      const dates = this.getDates(new Date(startDate), new Date(endDate));
     

      this.dailyDataFilter = dates;
      const datesPeriodsAux = [];
      dates.forEach((date) =>
        datesPeriodsAux.push(this.setDailyPeriodsTable(date))
      );
      const datesPeriods = [];
      for (let dates of datesPeriodsAux) {
        for (let date of dates) {
          datesPeriods.push(date);
        }
      }
      const groupedDatesPeriods = datesPeriods.reduce((r, a) => {
        r[a.name] = r[a.name] || [];
        r[a.name].push(a);
        return r;
      }, Object.create(null));

      const values = Object.values(groupedDatesPeriods);

      values.forEach((e, index) => {
        this.dailyPeriodsTable.dates.push({
          id: index + 1,
          name: e[0].name,
          date: e[0].date,
        });
      });
      this.filterSelected = filter;
    },

    fetchHourlyInterruptedHistoricalTable(filter) {
      this.filterSelected = filter;
      this.daily = false;
      const hourlyPeriods = [];
      this.hourlyDataFilter = [];
      this.hourlyPeriodsTable = [];

      for (let i = filter.hourStart; i <= filter.hourEnd; i++) {
        const rounds = this.setHoursTable(filter.date, i);
        for (let r of rounds) {
          hourlyPeriods.push(r);
        }

        this.hourlyDataFilter.push(rounds[2].date);
      }



      const gorupHoursPeriods = hourlyPeriods.reduce((r, a) => {
        r[a.name] = r[a.name] || [];
        r[a.name].push(a);
        return r;
      }, Object.create(null));
      const values = Object.values(gorupHoursPeriods);
      values.forEach((e, index) => {
        this.hourlyPeriodsTable.push({
          id: index + 1,
          name: e[0].name,
          date: e[0].date,
        });
      });

    },

    toggleNavigation() {
      this.navigation.show = !this.navigation.show;
    },
    toggleTypeHistorical(item) {


      this.typeHistoricalSelected = { ...item };
    },

    getDates(startDate, endDate) {
      const dates = [];
      let currentDate = startDate;
      const addDays = function (days) {
        const date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
      };
      while (currentDate <= endDate) {
        dates.push(currentDate);
        currentDate = addDays.call(currentDate, 1);
      }
      return dates;
    },

    setDailyPeriodsTable(date) {
      const dates = [
        {
          id: 1,
          name: moment(date).subtract(4, "days").format("ddd. DD/MM/YYYY"),
          date: moment(date)
            .subtract(4, "days")
            .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
        },
        {
          id: 2,
          name: moment(date).subtract(3, "days").format("ddd. DD/MM/YYYY"),
          date: moment(date)
            .subtract(3, "days")
            .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
        },
        {
          id: 3,
          name: moment(date).subtract(2, "days").format("ddd. DD/MM/YYYY"),
          date: moment(date)
            .subtract(2, "days")
            .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
        },
        {
          id: 4,
          name: moment(date).subtract(1, "days").format("ddd. DD/MM/YYYY"),
          date: moment(date)
            .subtract(1, "days")
            .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
        },
        {
          id: 5,
          name: moment(date).format("ddd. DD/MM/YYYY"),
          date: moment(date).format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
        },
      ];

      return dates;
    },

    setHoursTable(date, hour) {


      const hourlyPeriods = [
        {
          name: moment(date)
            .hour(hour)
            .subtract(2, "hours")
            .format("DD/MM/YYYY HH:mm"),
          date: moment(date)
            .hour(hour)
            .subtract(2, "hours")
            .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
          hour: hour,
        },
        {
          name: moment(date)
            .hour(hour)
            .subtract(1, "hours")
            .format("DD/MM/YYYY HH:mm"),
          date: moment(date)
            .hour(hour)
            .subtract(1, "hours")
            .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
          hour: hour,
        },
        {
          name: moment(date).hour(hour).format("DD/MM/YYYY HH:mm"),
          date: moment(date).hour(hour).format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
          hour: hour,
        },
      ];

      return hourlyPeriods;
    },
  },
};
</script>


<style scoped lang="scss">
.screen-xl {
  padding-left: 50px;
  padding-right: 50px;
}
.screen-under-xl {
  padding-left: 20px;
  padding-right: 20px;
}

::v-deep .v-navigation-drawer__content {
  background-color: #1b1f2d !important;
  // border-radius: 16px 0px 0px 0px  !important;
}

::v-deep .v-navigation-drawer__content {
  background-color: #1b1f2d !important;
  border-radius: 16px 0px 0px 0px !important;
}
</style>
